const Uint64BE = require('int64-buffer').Uint64BE

export const getInt2 = (bytesArray, start, end = null, option = null) => {
  if (!end) end = start + 4
  const byteArray = new Int8Array(bytesArray.slice(start, end))
  const length = byteArray.length
  let returnInt = 0
  byteArray.forEach((b, index) => {
    returnInt += (b * (256 ** (length - 1 - index)))
  })
  if (returnInt < 0 && option && option.isGreatThan0 === true) {
    const byteArray2 = new Uint8Array(bytesArray.slice(start, end))
    returnInt = 0
    byteArray2.forEach((b, index) => {
      returnInt += (b * (256 ** (length - 1 - index)))
    })
  }
  return returnInt
}

export const getInt = (bytesArray, start, end = null) => {
  if (!end) end = start + 4
  const byteArray = new Uint8Array(bytesArray.slice(start, end))
  const length = byteArray.length
  let returnInt = 0
  byteArray.forEach((b, index) => {
    returnInt += (b * (256 ** (length - 1 - index)))
  })
  return returnInt
}

export const getByteIndex = (bytesArray, byteMatch, start) => {
  if (!start) start = 0
  const byteArray = new Int8Array(bytesArray)
  const length = byteArray.length
  for (let i = start; i < length; i += 1) {
    const b = byteArray[i]
    if (b === byteMatch) {
      return i
    }
  }
  return -1
}

export const getRawVarint32 = (bytesArray) => {
  const view = new DataView(bytesArray)

  let size = 0
  let value = 0
  let temp

  do {
    temp = view.getUint8(size)
    if (size < 5) {
      // eslint-disable-next-line no-bitwise
      value |= ((temp & 0x7F) << (7 * size)) >>> 0
    }
    size += 1
    // eslint-disable-next-line no-bitwise
  } while ((temp & 0x80) === 0x80)
  // eslint-disable-next-line no-bitwise
  value |= 0 // Make sure to discard the higher order bits

  return { intResult: value, bufferPos: size }
}

export const getRawLittleEndian64 = (bytesArray) => {
  const byteArray = new Uint8Array(bytesArray.slice(0, 8))
  const bigint = new Uint64BE(byteArray.reverse())

  return bigint.toNumber()
}

export const getBytes = (bytesArray) => {
  const { intResult, bufferPos } = getRawVarint32(bytesArray)
  const size = intResult
  if (size === 0) return []
  if (size > 0) {
    return { bytesResult: bytesArray.slice(bufferPos, bufferPos + size), bufferPos: bufferPos + size }
  }
  return { bytesResult: null, bufferPos }
}

export const toUTF8Array = (str) => {
  const utf8 = []
  for (let i = 0; i < str.length; i += 1) {
    let charcode = str.charCodeAt(i)
    if (charcode < 0x80) utf8.push(charcode)
    else if (charcode < 0x800) {
      // eslint-disable-next-line no-bitwise
      utf8.push(0xc0 | (charcode >> 6), 0x80 | (charcode & 0x3f))
    } else if (charcode < 0xd800 || charcode >= 0xe000) {
      // eslint-disable-next-line no-bitwise
      utf8.push(0xe0 | (charcode >> 12), 0x80 | ((charcode >> 6) & 0x3f), 0x80 | (charcode & 0x3f))
    } else { // surrogate pair
      i += 1
      // UTF-16 encodes 0x10000-0x10FFFF by
      // subtracting 0x10000 and splitting the
      // 20 bits of 0x0-0xFFFFF into two halves
      // eslint-disable-next-line no-bitwise
      charcode = 0x10000 + (((charcode & 0x3ff) << 10) | (str.charCodeAt(i) & 0x3ff))
      // eslint-disable-next-line no-bitwise
      utf8.push(0xf0 | (charcode >> 18), 0x80 | ((charcode >> 12) & 0x3f), 0x80 | ((charcode >> 6) & 0x3f), 0x80 | (charcode & 0x3f))
    }
  }
  return utf8
}
